module.exports = __webpack_public_path__ + "media/images/NewBMP-a1f5c132130659b59d890c3ba50547e4.jpg";